import { GetBusinessEntitiesResponse } from '../models/http-responses/iam.response.type'
import IamApi from '../services/weir_iam_service'

export const getBusinessEntitiesDetail = async (roleId: string) => {
    return IamApi.get<string, GetBusinessEntitiesResponse>(
        `/iamservice/application-roles/${roleId}/business-entities`
    )
}

export const deleteAccount = () => {
    return IamApi.delete(
        `/iamservice/user/delete-self/${process.env.REACT_APP_MSAL_CLIENT_ID}`
    )
}
